/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...



(function () {

   var tabTitles = document.querySelectorAll('.tab-title');
 
   

    if(tabTitles&&tabTitles.length>0){
    var t;

        // var url = document.location.search
        // var obj = {}
        // if(url){
        // var params = url.substr(1).split('&')
        //     params.map(function(v){
        //         obj[v.split("=")[0]] = v.split("=")[1]
        //     })
        // }

        // if(!obj.tab){
        //     var newQuery = insertParam('tab',tabTitles[0].innerHTML.toLowerCase().trim())
        //     window.history.replaceState('','',newQuery);
        // }

        var maodian = window.location.hash
        if(maodian){
            var maodianName = null
            if(maodian.indexOf('?')>-1){
                maodianName = maodian.split('?')[0]
            }else{
              maodianName = maodian
            }
        }


        for (t = 0; t < tabTitles.length; t++) {
            
            (function (index) {
               var tabName = '#'+tabTitles[index].innerHTML.toLowerCase().trim()
              // var tabName = '#tab'+(t+1)
              
                if(tabName === maodianName){ // obj.tab
                    var tabTitleActive1 = document.querySelector('.tab-title.active');
                    tabTitleActive1.classList.toggle("active")
                    tabTitles[index].classList.toggle("active");
                    var tabId = tabTitles[index].getAttribute('data-toggle')
                    var tabContent = document.querySelector('.tab-panel.active').classList.remove('active')
                    document.querySelector('#' + tabId).classList.add('active')
                }
                
                tabTitles[t].addEventListener("click", function () {
                // var tabName = this.innerHTML.toLowerCase().trim()
                    // var newQuery = insertParam('tab',tabName)
                    // window.history.replaceState('','',newQuery);
                    if (this.classList.contains('active')) return
                    var tabTitleActive = document.querySelector('.tab-title.active');
                    tabTitleActive.classList.toggle("active")
                    this.classList.toggle("active");
                    var tabId = this.getAttribute('data-toggle')
                    var tabContent = document.querySelector('.tab-panel.active').classList.remove('active')
                    document.querySelector('#' + tabId).classList.add('active')
                })
            })(t)
        }
    }
    
    // var t;
    //     for (t = 0; t < tabTitles.length; t++) {
    //         tabTitles[t].addEventListener("click", function () {
    //             if (this.classList.contains('active')) return
    //             var tabTitleActive = document.querySelector('.tab-title.active');
    //             tabTitleActive.classList.toggle("active")
    //             this.classList.toggle("active");
    //             var tabId = this.getAttribute('data-toggle')
    //             var tabContent = document.querySelector('.tab-panel.active').classList.remove('active')
    //             document.querySelector('#' + tabId).classList.add('active')
    //         })
    //     }

    function insertParam(key, value){
        key = encodeURI(key);
        value = encodeURI(value);
        var url = document.location.search

        var obj = {}
        if(url){
        var params = url.substr(1).split('&')
            params.map(function(v){
                obj[v.split("=")[0]] = v.split("=")[1]
            })
        }
            obj[key] = value

        var queryStr = Object.keys(obj).map(function (key) {
                return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
            }).join('&');

            return '?'+queryStr
    }

    function handleShowHidePanel(dom,activeClass,firstAddClass){
        var nodes = document.querySelectorAll(dom);
        var k;
        for (k = 0; k < nodes.length; k++) {
            if (k == 0) {
                var firstContent = nodes[0].nextElementSibling  //firstContent.scrollHeight
                firstContent.style.maxHeight = 500 + "px";
                if(firstAddClass){
                    nodes[0].classList.add(activeClass)
                }
            }
    
            (function (index) {
                // nodes[index].addEventListener("click", function () {
                //     this.classList.toggle(activeClass);
                //     var panel = this.nextElementSibling;
                //     if (panel.style.maxHeight) {
                //         panel.style.maxHeight = null;
                //     } else {
                //         panel.style.maxHeight = panel.scrollHeight + "px";
                //     }
                // });

                nodes[index].addEventListener("click", function () {
                    this.classList.toggle(activeClass);
                    var panel = this.nextElementSibling;
                    var type = this.getAttribute("data-type")
                    if(type == 'faq'){
                        var parentsMaxHeight = this.parentElement.parentElement.style.maxHeight
                        var parentsMaxHeightNum = Number(parentsMaxHeight.replace('px',''))
                        var lastHeight = parentsMaxHeightNum
                       
                        var scrollHeight = panel.scrollHeight
                        if (panel.style.maxHeight) {
                            panel.style.maxHeight = null;
                            lastHeight = parentsMaxHeightNum-scrollHeight
                        } else {
                            panel.style.maxHeight = scrollHeight + "px";
                            lastHeight = parentsMaxHeightNum + scrollHeight
                        }
                        this.parentElement.parentElement.style.maxHeight = lastHeight + "px"
                    }else{
                        if (panel.style.maxHeight) {
                            panel.style.maxHeight = null;
                        } else {
                            panel.style.maxHeight = panel.scrollHeight + "px";
                        }
                    }
                });
            })(k)
        }
    }

    handleShowHidePanel('.page_faq_title','title-active',true)
    handleShowHidePanel('.faq-title','active',true)



 /****   lucky-coupon-popup start   *******/
    var runing = false

    $('#lucky-email').on('focus',function(){
        $('.error').css({'display':'none'})
		$('.error').text('')
    })

    $('#shipTheSheel').on('click',function(){
       if(runing) return 
       var email = document.getElementById('lucky-email').value
       var expr = /^[\.A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)$/
       if (!expr.test(email)) {
            $('.error').css({'display':'block'})
			$('.error').text('Email format is incorrect')
            runing = false
			return
		}else{
            $('.error').css({'display':'none'})
			$('.error').text('')
        }

        runing = true
      
        jQuery.ajax({
            type: 'POST',
            url: baseUrl+'/official/website/choose/coupon',
            data: JSON.stringify({email:email}),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success:function(response){

              if(response.code&&response.code !=='200'){
                $('.error').css({'display':'block'})
			    $('.error').text(response.message )
                runing = false
                return 
              }
                var discount = ['15%', '20%', '25%', '30%', '50%','10%'];
                var n = discount.indexOf(response.result.percentage)
                var radis = 60,
                initRadis = 10 * 360,
                time = 16*1000,
                totalRadis = initRadis - (radis * n + radis / 2),
               
                once = true
                if(once){
                    once = false
                    setTimeout(function(){
                        $('#runing').css('display','block')
                        $('.inner-content').css('display','none')
                        $('.big-circle').css({transform: 'rotate('+ totalRadis +'deg)','transition':'transform 15s cubic-bezier(0,.47,.31,1.03)'})
                    },10)
                   
                    setTimeout(function(){
                        once = true;
                        runing = false

                        var promoExpiry = $(".js-popup-lucky-coupon").data("promo-expiry");
                        Cookies('lucky-promo-showed', "2", {
                            expires: promoExpiry,
                            path: "/"
                        });

                        // success
                        $('.location').css('display','none')
                        $('.big-circle').css('display','none')
                        $('.inner-circle').css('display','none')

                        $('.luck').css('display','block')
                        $('.lucky-success-bg').css('display','block')
                        $('.discount').html( response.result.percentage + ' Discount Coupon')
                        $('.discount-value').html(response.result.coupon)
                        
                    },time)
                }
            },
            error:function(){
                $('.error').css({'display':'block'})
			    $('.error').text('Server Error' )
            }
        });
    })
    

 /****   lucky-coupon-popup end   *******/



})()